import { FC } from 'react';

interface Props {
  title: string;
}

// -----------------------------------------------------------------------------
const CategoryHeader: FC<Props> = props => {
  const { title } = props;

  return (
    <div className='page-header'>
      <h1>{title}</h1>
    </div>
  );
};

export default CategoryHeader;
